import { html, ref } from '@microsoft/fast-element';
import { deleteIcon } from '../../../styles';
import type { CancelModal } from './cancel-modal';

export const CancelModalTemplate = html<CancelModal>`
  <right-side-modal
    ${ref('cancelModal')}
    show="${(x) => x.show}"
    width="${(x) => x.width}"
    header="Cancel ${(x) => x.objectType === 'VPPA' ? 'Contract' : x.objectType}"
    @modalClosing="${(x) => x.closeDialog()}"
  >
    <div class="dialog-content">
      <p>${(x) => x.description}</p>
      <p id="red-text">This action cannot be undone.</p>
    </div>
    <zero-button
      slot="buttons"
      appearance="tertiary"
      class="button-length cancel-button"
      @click="${(x) => x.submitCancellation()}"
    >
      ${deleteIcon('start')}Cancel ${(x) => x.objectType === 'VPPA' ? 'Contract' : x.objectType}
    </zero-button>
  </right-side-modal>
`;
